module.exports = __webpack_public_path__ + "img/document.8c4fa60c.svg";